import * as types from './action-types';
import {getAppsByCategory, getFeaturedApps, getNewApps, getMostPopularApps, getBusinessApps, getAllApps, APPS_PER_PAGE} from '../services/market-api';
import {errorPage} from './mode';

export function requestApps(category) {
  return {
    type: types.REQUEST_APPS_BY_CATEGORY,
    category
  };
}

export function receiveApps(category, json, before = []) {
  return {
    type: types.RECEIVE_APPS_BY_CATEGORY,
    category,
    items: before.concat(json),
    receivedAt: Date.now(),
    loadedAll: json.length < APPS_PER_PAGE
  };
}

function fetchApps(category, lang, page, config) {
  return dispatch => {
    dispatch(requestApps(category));

    return getApps(category, lang, getOffset(page), config)
      .then(json => dispatch(receiveApps(category, json)))
      .catch((err) => {
        dispatch(errorPage(err.message, err._responseStatus));
        return dispatch(receiveApps(category, []));
      });
  };
}


export function fetchAppsIfNeeded(category, page) {
  return (dispatch, getState) => {
    const state = getState();
    const apps = state.appsByCategory[category];
    const config = {
      isPremium: state.mode.siteProfile.isSitePremium,
      experiments: state.mode.experiments
    };

    if (!apps) {
      return dispatch(fetchApps(category, state.mode.lang, page, config));
    }
  };
}

export function fetchAppsIfNeededNextPage(category, page) {
  return (dispatch, getState) => {
    const state = getState();
    const apps = state.appsByCategory[category];
    const config = {
      isPremium: state.mode.siteProfile.isSitePremium,
      experiments: state.mode.experiments
    };

    if (apps && !apps.isFetching && !apps.loadedAll) {
      dispatch(requestApps(category));

      return getApps(category, state.mode.lang, getOffset(page) + apps.items.length, config)
        .then(json => dispatch(receiveApps(category, json, apps.items)));
    }
  };
}

function getOffset(page) {
  return ((Number(page) || 1) - 1) * APPS_PER_PAGE;
}

// TODO remove this and use just getAppsByCategory when RedirectToOneAppMarket merged
function getApps(category, lang, offset, config) {
  switch (category) {
    case 'main':
      return offset ? Promise.resolve([]) : getFeaturedApps(lang);

    case 'new':
      return offset ? Promise.resolve([]) : getNewApps(lang);

    case 'popular':
      return offset ? Promise.resolve([]) : getMostPopularApps(lang);

    case 'business':
      return offset ? Promise.resolve([]) : getBusinessApps(lang);

    case 'all':
      return getAllApps(lang, offset);

    default:
      return getAppsByCategory(category, lang, offset, config);
  }
}



// WEBPACK FOOTER //
// ./actions/apps-by-category.js